import { createContext, useContext } from 'react';
import { DEFAULT_LOCALE } from '../../constants';
const TranslationStatusContext = createContext({
    loadedLocale: DEFAULT_LOCALE,
});
export const TranslationStatusContextProvider = TranslationStatusContext.Provider;
export const useTranslationStatus = () => useContext(TranslationStatusContext);
//# sourceMappingURL=useTranslationStatus.js.map